import {
    VEHICLE_SALARY_REPORT_REQUEST,
    VEHICLE_SALARY_REPORT_SUCCESS,
    VEHICLE_SALARY_REPORT_FAILURE,
    VEHICLE_SALARY_REPORT_FILTER_REQUEST,
    VEHICLE_SALARY_REPORT_FILTER_SUCCESS,
    VEHICLE_SALARY_REPORT_FILTER_FAILURE,
    VEHICLE_SALARY_REPORT_PRINT_REQUEST,
    VEHICLE_SALARY_REPORT_PRINT_SUCCESS,
    VEHICLE_SALARY_REPORT_PRINT_FAILURE,
    VEHICLE_SALARY_REPORT_STATUS_REQUEST,
    VEHICLE_SALARY_REPORT_STATUS_SUCCESS,
    VEHICLE_SALARY_REPORT_STATUS_FAILURE,

  } from "../types/vehicle-salary-types.js";
  
  const initialState = {
    vehicleSalaryReport: {},
    vehicleSalaryFiltersReport: {},
    vehicleSalaryReportPrint: {},
    loading: false,
    error: null,
  };
  
  const vehicleSalaryReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case VEHICLE_SALARY_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case VEHICLE_SALARY_REPORT_FILTER_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      case VEHICLE_SALARY_REPORT_PRINT_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        };
      }
      // case VEHICLE_SALARY_REPORT_STATUS_REQUEST: {
      //   return {
      //     ...state,
      //     loading: true,
      //     error: null
      //   };
      // }
      // case VEHICLE_SALARY_REPORT_STATUS_SUCCESS: {
      //   return {
      //     ...state,
      //     loading: false,
      //     error: null
      //   };
      // }
      // case VEHICLE_SALARY_REPORT_STATUS_FAILURE: {
      //   return {
      //     ...state,
      //     loading: false,
      //     error: null
      //   };
      // }
      case VEHICLE_SALARY_REPORT_SUCCESS: {
        return {
          ...state,
          vehicleSalaryReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case VEHICLE_SALARY_REPORT_FILTER_SUCCESS: {
        return {
          ...state,
          vehicleSalaryFiltersReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case VEHICLE_SALARY_REPORT_PRINT_SUCCESS: {
        return {
          ...state,
          vehicleSalaryReportPrint: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case VEHICLE_SALARY_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case VEHICLE_SALARY_REPORT_FILTER_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      case VEHICLE_SALARY_REPORT_PRINT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default vehicleSalaryReportReducer;
  